export default function HeroSection() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/57c982531ce74d8992a8785896e0bafd/06221fec588d6c1caad9b0aa71a37268.jpeg"
          alt="Alaqua Country Club Golf Course"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto pt-20 md:pt-28">
        <h1 className="text-white mb-4 sm:mb-6">
          <span className="block text-xl sm:text-2xl md:text-3xl font-light mb-2 sm:mb-3">
            Bucket List Golf Presents:
          </span>
          <span className="block text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-yellow-400 leading-tight">
            Post-PGA Show Bucket List Event
          </span>
        </h1>

        <div className="space-y-3 sm:space-y-4 mb-8 sm:mb-10 md:mb-12">
          <div className="flex items-center justify-center text-white">
            <i className="ri-calendar-line text-xl sm:text-2xl mr-2 sm:mr-3"></i>
            <span className="text-base sm:text-lg md:text-xl font-medium">January 23rd, 2026</span>
          </div>
          <div className="flex items-center justify-center text-white">
            <i className="ri-time-line text-xl sm:text-2xl mr-2 sm:mr-3"></i>
            <span className="text-base sm:text-lg md:text-xl font-medium">10:00 AM Tee Times</span>
          </div>
          <div className="flex items-center justify-center text-white">
            <i className="ri-map-pin-line text-xl sm:text-2xl mr-2 sm:mr-3"></i>
            <span className="text-base sm:text-lg md:text-xl font-medium">Alaqua Country Club, Longwood, FL</span>
          </div>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6">
          <a
            href="#register-multiple"
            className="w-full sm:w-auto bg-emerald-600 text-white px-8 sm:px-10 py-3 sm:py-4 rounded-md text-base sm:text-lg font-semibold hover:bg-emerald-700 transition-colors shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Register Now - $225
          </a>
          <a
            href="#about"
            className="w-full sm:w-auto bg-white/90 text-gray-900 px-8 sm:px-10 py-3 sm:py-4 rounded-md text-base sm:text-lg font-semibold hover:bg-white transition-colors shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
          >
            Learn More
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce hidden sm:block">
        <i className="ri-arrow-down-line text-white text-3xl"></i>
      </div>
    </section>
  );
}
